import React, { Fragment } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { FormattedMessage } from 'react-intl';
import { times } from 'lodash';

import UserDevice from 'services/user-device';
import messages from '../../messages';
import CheckListItem from './CheckListItem';

import './combinations.scss';

interface Props {
    betslipBetId: string;
    betslipOddsSize: number;
    closeBtn?: JSX.Element;
}

const Combinations: React.FC<Props> = ({
    betslipOddsSize,
    betslipBetId,
    closeBtn,
}) => {
    const isMobile = UserDevice.getInstance()?.isDeviceMobile();
    const Wr = isMobile ? Fragment : Scrollbars;

    let height: string | undefined;

    if (!isMobile) {
        // TODO: remove hardcode
        // height = `${(betslipOddsSize - 2) * 46}px`;
        height = `${138}px`;
    }

    return (
        <React.Fragment>
            <div styleName="title" className="__app-Combinations-title">
                <FormattedMessage {...messages.selectCombinations} />
                {closeBtn}
            </div>
            <div
                styleName="container"
                className="__app-Combinations-container"
                style={{
                    height,
                }}
            >
                {betslipOddsSize > 10 ? (
                    <div styleName="error">
                        <FormattedMessage {...messages.errorMaxSystem} />
                    </div>
                ) : (
                    <Wr>
                        {times(betslipOddsSize)
                            .slice(2)
                            .map(index => (
                                <CheckListItem
                                    key={index}
                                    betslipBetId={betslipBetId}
                                    combinationNumber={index}
                                />
                            ))}
                    </Wr>
                )}
            </div>
        </React.Fragment>
    );
};

export default React.memo(Combinations);
